import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-收益分析",
  "use": "icon-收益分析-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-收益分析\"><path d=\"M64 960h928a32 32 0 0 1 0 64H32a32 32 0 0 1-32-32V32a32 32 0 0 1 64 0zm91.008-124.8a32 32 0 1 1-54.016-34.432l256-402.048a32 32 0 0 1 46.336-8.32l230.784 175.104 330.304-425.152a32 32 0 0 1 50.56 39.296L665.28 629.76a32 32 0 0 1-44.608 5.888L392.32 462.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol